module.exports = __webpack_public_path__ + "f1e040ee9723029bee599bbaebd3516e.png";